<script setup lang="ts">
onMounted(() => {
  // アプリからシェアボタンを押されたことを受信するための処理を記述
  // onBeforeUnmount で removeEventListener するために、addEventListener には
  // 無名関数ではなく onRequestAppAction 自体（の参照）を渡す
  window.addEventListener('message', onRequestAppAction)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', onRequestAppAction)
})

const onRequestAppAction = (event: MessageEvent<string>): void => {
  useNuxtApp().$onRequestAppAction(event, useShareContents().value)
}
</script>
<template>
  <div>
    <NuxtPage />
  </div>
</template>
